import * as Yup from 'yup'
import { MAGIC_NUMBER } from '../../constants/magicNumbers';

const requiredFieldText = 'This field is required';
const requiredSelectionText = 'At least one selection is required';
const requiredTermsAndConditions = "Please accept the Terms & Conditions before proceeding.";

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const passwordRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;

export const AddPhoneNumberSchema = Yup.object().shape({
  phoneNumber: Yup.string().required(requiredFieldText).max(MAGIC_NUMBER.MAX_PHONE_DIGITS, `Can't be more than ${MAGIC_NUMBER.MAX_PHONE_DIGITS} digits`)
});

export const AddEmailSchema = Yup.object().shape({
  email: Yup.string().ensure().email('Email address is not valid').required(requiredFieldText)
});

export const VerifyOTPSchema = Yup.object().shape({
  otp: Yup.string().required('OTP is required.').length(MAGIC_NUMBER.OTP_DIGITS, `OTP must be ${MAGIC_NUMBER.OTP_DIGITS} characters long.`)
});

export const UserInfo1Schema = Yup.object().shape({
  firstName: Yup.string().required(requiredFieldText),
  lastName: Yup.string().required(requiredFieldText),
  terms: Yup.boolean().oneOf([true], requiredTermsAndConditions),
  email: Yup.string()
    .when('signUpMethod', {
      is: 'email',
      then: Yup.string().ensure().email('Email address is not valid').required(requiredFieldText)
    }),
  phoneNumber: Yup.string()
    .when('signUpMethod', {
      is: 'email',
      then: Yup.string().required(requiredFieldText)
        .max(MAGIC_NUMBER.MAX_PHONE_DIGITS, `Can't be more than ${MAGIC_NUMBER.MAX_PHONE_DIGITS} digits`)
        .min(MAGIC_NUMBER.MIN_PHONE_DIGITS, `Can't be less than ${MAGIC_NUMBER.MIN_PHONE_DIGITS} digits`)
    }),
  password: Yup.string()
    .when('signUpMethod', {
      is: 'email',
      then: Yup.string().required(requiredFieldText)
        .min(8, 'Password too short! Must be at least 8 characters in length')
        .matches(passwordRegExp,
          "Password must contain One Uppercase, One Lowercase, One Number and one special case Character"
        )
    })
});

export const UserInfo2Schema = Yup.object().shape({
  // password: Yup.string().required(requiredFieldText)
  //   .min(8, 'Password too short! Must be at least 8 characters in length')
  //   .matches(passwordRegExp,
  //     "Password must contain One Uppercase, One Lowercase, One Number and one special case Character"
  //   ),
  // passwordConfirm: Yup.string()
  //   .oneOf([Yup.ref('password'), null], "Passwords must match")
  //   .required(requiredFieldText),
  profilePhoto: Yup.string().required("A profile photo is required"),
  referralType: Yup.array().min(1, requiredSelectionText).required(requiredSelectionText),
  referralText: Yup.string()
    .when(['referralType'], {
      is: (referralType) => referralType.indexOf('other') > -1,
      then: Yup.string().required(requiredFieldText)
    }),
});

export const CreditCardSchema = Yup.object().shape({
  cardName: Yup.string().required(requiredFieldText),
  billAddr1: Yup.string().required(requiredFieldText),
  billCity: Yup.string().required(requiredFieldText),
  billState: Yup.string().required(requiredFieldText)
});

export const BankAccountSchema = Yup.object().shape({
  bankHolderName: Yup.string().required(requiredFieldText),
  bankRoutingNumber: Yup.number().required(requiredFieldText),
  bankAccountNumber: Yup.number().required(requiredFieldText)
})

